export default { 
    'PPTlist.Document':'Orations',
    'PPTlist.noDataTips': 'No relevant results found',
    'PPTlist.Edited':'Edited',
    'PPTlist.delModel.ok':'OK',
    'PPTlist.delModel.cancel':'Cancel',
    'PPTlist.delModel.title':'Remove Oration',
    'PPTlist.delModel.content':'Once deleted, it cannot be retrieved.',
}